import { render, staticRenderFns } from "./SituacaoPillFornecedor.vue?vue&type=template&id=05269688&scoped=true"
import script from "./SituacaoPillFornecedor.vue?vue&type=script&lang=js"
export * from "./SituacaoPillFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05269688",
  null
  
)

export default component.exports